/**
 * Format a numeric string with locale-appropriate thousand and decimal separators.
 *
 * Non-numeric input (e.g. "-", empty strings, text) is returned unchanged.
 *
 * @param value  Raw numeric string (e.g. "1234.56", "0", "-42")
 * @param lang   Target locale — "nb" uses space / comma, "en" uses comma / period
 */
export function formatNumber(value: string, lang: "nb" | "en" = "nb"): string {
  if (!value || value.trim() === "") return value

  // Quick check: does this look like a number?
  // Matches optional negative sign, digits, optional decimal part
  if (!/^-?\d+(\.\d+)?$/.test(value.trim())) return value

  const trimmed = value.trim()
  const [intPart, decPart] = trimmed.split(".")

  const thousandSep = lang === "nb" ? "\u00A0" : "," // Non-breaking space for nb (special unicode character)
  const decimalSep = lang === "nb" ? "," : "."

  // Insert thousand separators (handles negative sign correctly)
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep)

  if (decPart !== undefined) {
    return `${formattedInt}${decimalSep}${decPart}`
  }

  return formattedInt
}
